<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">{{ $t("CMS") }}</div>
    </div>

    <div class="white-wrapper my-3">
      <section
        class="mb-3 w-100 px-3 cms-section-new"
        v-for="(cms_content, CMSIndex) in CMSArray"
        :key="CMSIndex"
      >
        <div
          class="section-title mb-3 d-flex justify-content-between section-collapse-box"
          @click="handleCollapse(cms_content)"
        >
          <span> {{ cms_content.type_name }} </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse class="mt-2" v-model="cms_content.isCollapsed">
          <div
            class="bn-tabs-nav"
            v-if="
              cms_content.keydata.length > 0 && cms_content.islanguageAvailable
            "
          >
            <button
              v-for="(content, contentIndex) in cms_content.keydata"
              :key="contentIndex"
              :class="[
                'btn-tab-title ',
                { active: contentIndex == activeClass },
              ]"
              @click.prevent.stop="onChangeTabHandler($event, contentIndex)"
            >
              <strong>
                <span :class="notempty[contentIndex] ? '' : 'text-danger'">{{
                  content.langauge
                }}</span>
              </strong>
            </button>
          </div>
          <div class="bn-tabs-content" v-if="cms_content.keydata.length > 0">
            <div
              v-for="(content, contentIndex) in cms_content.keydata"
              :key="contentIndex"
            >
              <div
                v-if="
                  (contentIndex === activeClass &&
                    cms_content.islanguageAvailable) ||
                    !cms_content.islanguageAvailable
                "
              >
                <div class="row mx-0 rounded mb-4">
                  <div class="col-12">
                    <div class="row">
                      <div
                        :class="
                          item.type == 'textarea'
                            ? 'col-lg-12 col-xl-12 align-self-center mb-3'
                            : item.type == 'radio'
                            ? 'col-md-4 mb-4'
                            : 'col-lg-6 col-xl-6 mb-3'
                        "
                        v-for="(item, itemIndex) in cms_content.key"
                        :key="itemIndex"
                      >
                        <div
                          class="d-flex justify-content-between align-item-center"
                          v-if="item.type == 'file'"
                        >
                          <label
                            class="material-file-upload cms_header_image"
                            @click.prevent.stop="
                              setCMSImageData(
                                'ondemand',
                                contentIndex,
                                CMSIndex,
                                item.key_name
                              )
                            "
                          >
                            <div
                              class="label"
                              v-bind:class="{
                                'shift-up': content[item.key_name],
                              }"
                            >
                              {{ item.label }}
                            </div>
                            <div class="uploaded-file-name">
                              <div class="text-truncate pt-2">
                                {{ content[item.key_name] }}
                              </div>
                            </div>
                          </label>

                          <Tooltip class="mt-2" :title="item.label" />
                          <img
                            width="40"
                            height="40"
                            class="rounded c-pointer ml-2"
                            @click="
                              openImageModal(
                                'ondemand',
                                contentIndex,
                                CMSIndex,
                                item.key_name
                              )
                            "
                            :src="_GetImagePath(content[item.key_name])"
                            v-if="content[item.key_name]"
                          />
                          <img
                            v-else
                            width="35"
                            height="35"
                            class="rounded ml-2"
                            alt="Empty Image"
                            src="@/assets/img/icons/empty-image.svg"
                          />
                        </div>
                        <div
                          class="d-flex align-items-center"
                          v-if="item.type == 'textarea'"
                        >
                          <div class="input-material-textarea">
                            <textarea
                              v-model="content[item.key_name]"
                              rows="4"
                              placeholder="."
                              name="description"
                              @input="
                                CheckEmptyContent(
                                  content[item.key_name],
                                  contentIndex,
                                  CMSIndex
                                )
                              "
                            ></textarea>
                            <label>{{ item.label }}</label>
                          </div>
                          <Tooltip :title="item.label" />
                        </div>
                        <div v-if="item.type == 'text'">
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <input
                                placeholder="."
                                type="text"
                                v-model="content[item.key_name]"
                              />
                              <label>{{ item.label }}</label>
                            </div>
                            <Tooltip :title="item.label" />
                          </div>
                        </div>
                        <div v-if="item.type == 'radio'">
                          <div class="row mt-2">
                            <div class="col-md-6">
                              <label>{{ item.label }}</label>
                            </div>
                            <div class="col-md-4">
                              <b-form-checkbox
                                v-model="content[item.key_name]"
                                value="Y"
                                unchecked-value="N"
                                name="check-button"
                                switch
                              ></b-form-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>
      <div class="text-center">
        <button @click.prevent.stop="finalSubmit()" class="btn-blue">
          {{ $t("save") }}
        </button>
      </div>
    </div>
    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">{{ PreviewHeading }}</label>
      <button
        class="btn-modal-close"
        @click="$bvModal.hide('selected-image-preview-modal')"
      >
        &times;
      </button>
      <br />
      <img
        v-if="previewType == 1"
        :src="
          _GetImagePath(
            CMSArray[previewCMSIndex].keydata[previewLanguage][keyname]
          )
        "
        class="img-fluid"
      />
      <div v-else class="mx-auto w-100">
        {{ "No Preview Available" }}
      </div>
    </b-modal>
    <ImageGallery
      v-bind:propImageName="calledBy == 1 ? 'Image' : 'Image'"
      v-bind:openModal="showModal"
      v-bind:set_height="NaN"
      v-bind:set_width="NaN"
      :showPercentageLoader="true"
      :img_desc="'CMS Image'"
      :resetImgData="false"
      :language="
        calledBy == 2 ? this.ContentLanguages[this.imageLangIndex] : {}
      "
      :category="'Others'"
    ></ImageGallery>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import MyCinemaService from "@/services/MyCinemaService";
  import MovieService from "@/services/MovieService";
  import ImageGallery from "../../Pages/ImageGallery/imageGalleryModal.vue";
  import VueCropper from "vue-cropperjs";
  import "cropperjs/dist/cropper.css";
  import { mapGetters } from "vuex";

  export default {
    components: { VueCropper, ImageGallery },
    data() {
      return {
        sectionCollapse: {
          onDemand: true,
          socialMedia: true,
          cmsSetting: true,
        },
        cmsSetting: {
          show_on_demand: "Y",
          show_now_showing: "Y",
          show_mini_festivals: "Y",
        },
        cms_content: [],
        socialMedia: {
          facebook_link: "",
          twitter_link: "",
        },
        ContentLanguages: [],
        activeClass: 0,
        notempty: [false, false, false, false, false, false],
        previewType: 0,
        previewLanguage: null,
        PreviewHeading: "",
        calledBy: 0,
        imageLangIndex: null,
        showModal: false,
        CMSArray: [],
        cmsIndex: null,
        keyname: "",
      };
    },
    computed: {
      ...mapGetters(["finalImagePath"]),
    },
    watch: {
      finalImagePath(newval) {
        if (this.calledBy == 1) {
          this.CMSArray[this.cmsIndex].keydata[this.imageLangIndex][
            this.keyname
          ] = newval;
          this.notempty[this.imageLangIndex] = true;
          // this.cms_content[this.imageLangIndex].onDemand.image_url = newval;
          this.$forceUpdate();
        }
      },
    },
    beforeMount() {
      // this.getContentLangauge();
      this.getCMSData();
    },
    methods: {
      handleCollapse(content) {
        content.isCollapsed = !content.isCollapsed;
      },
      onChangeTabHandler: function(event, index) {
        this.activeClass = index;
      },
      openImageModal: function(type, langIndex, index, keyname) {
        if (type == "ondemand") {
          this.previewType = 1;
          this.previewLanguage = langIndex;
          this.previewCMSIndex = index;
          this.keyname = keyname;
          this.PreviewHeading = "Image Preview";
        }
        this.$refs["preview-modal"].show();
      },
      setCMSImageData(type, langIndex, cmsIndex, keyName) {
        if (type == "ondemand") {
          this.calledBy = 1;
          this.imageLangIndex = langIndex;
          this.keyname = keyName;
          this.cmsIndex = cmsIndex;
          this.showModal = !this.showModal;
        }
      },
      CheckEmptyContent: function(content, langIndex, CMSIndex) {
        this.CMSArray[CMSIndex].keydata[langIndex];
        if (
          this.CMSArray[CMSIndex].keydata[langIndex].image_url ||
          this.CMSArray[CMSIndex].keydata[langIndex].sub_header
        ) {
          this.notempty[langIndex] = true;
        } else {
          this.notempty[langIndex] = false;
        }
      },
      getContentLangauge: function() {
        MovieService.GetMovieContentLanguages()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.ContentLanguages.length > 0) {
                // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
                //   "langauge"
                // ]);
                this.ContentLanguages = data.ContentLanguages;
              }
              console.log("this.ContentLanguages", this.ContentLanguages);
            } else {
              // Show Error:
              console.log("data.message :", data.message);
            }
            return;
          })
          .then(() => {
            this.makeLangContainers();
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error On getMovieContentLangauge :", error);
          });
      },
      _makeLangContainers: function() {
        this.ContentLanguages.map((x) => {
          let Obj = {
            ...x,
            cinema_id: null,
            onDemand: {
              image_url: "",
              sub_header: "",
            },
          };
          this.cms_content.push(Obj);
          console.log("this.cms_content", this.cms_content);
        });
      },
      makeLangContainers: function(Content = []) {
        let obj = [
          {
            type: 1,
            type_name: "On Demand",
            keydata: [],
            isCollapsed: true,
            islanguageAvailable: true,
            key: [
              {
                type: "file",
                key_name: "image_url",
                label: "On Demand Header Image",
              },
              {
                type: "textarea",
                key_name: "sub_header",
                label: "On Demand Sub header",
              },
            ],
          },
          {
            type: 2,
            type_name: "Social Media",
            keydata: [],
            isCollapsed: false,
            islanguageAvailable: false,
            key: [
              {
                type: "text",
                key_name: "facebok_link",
                label: "Facebook",
              },
              {
                type: "text",
                key_name: "twitter_link",
                label: "Twitter",
              },
            ],
          },
          {
            type: 3,
            type_name: "Homepage",
            keydata: [],
            isCollapsed: false,
            islanguageAvailable: false,
            key: [
              {
                type: "radio",
                key_name: "show_on_demand",
                label: "Show On Demand",
              },
              {
                type: "radio",
                key_name: "show_now_showing",
                label: "Show Now Showing",
              },
              {
                type: "radio",
                key_name: "show_mini_festivals",
                label: "Show Mini Festivals",
              },
            ],
          },
        ];
        obj.map((y) => {
          if (y.islanguageAvailable) {
            this.ContentLanguages.map((x) => {
              // let tempObj = x;
              let tempObj = {
                ...x,
                key: y.key,
              };
              y.key.map((z) => {
                tempObj[z.key_name] = "";
              });
              y.keydata.push(tempObj);
            });
          } else {
            let tempObj = {};

            y.key.map((z) => {
              if (z.type == "radio") {
                tempObj[z.key_name] = "Y";
              } else {
                tempObj[z.key_name] = "";
              }
            });
            y.keydata.push(tempObj);
          }
        });
        this.CMSArray = obj;

        console.log("OBJ test", obj);
        // this.ContentLanguages.map((x, i) => {
        //   let Array1 = [];
        //   Array1 = Content.filter(y => {
        //     return y.lang_id == x.langaugeId;
        //   });
        //   if (Array1.length > 0) {
        //     x["cinema_id"] = this.cinemaID;
        //     x["onDemand"] = JSON.parse(Array1[0].onDemand) || {
        //       image_url: "",
        //       sub_header: ""
        //     };
        //     x["cms_id"] = Array1[0].cms_id;

        //     if (x.onDemand.image_url || x.onDemand.sub_header) {
        //       this.notempty[i] = true;
        //     }
        //   } else {
        //     x["cinema_id"] = this.cinemaID;
        //     x["onDemand"] = {
        //       image_url: "",
        //       sub_header: ""
        //     };
        //   }
        // });
        // this.cms_content = this.ContentLanguages;
        this.$forceUpdate();
      },
      setModalData(height, width) {
        this.set_height = height;
        this.set_width = width;
        this.showModal = !this.showModal;
      },
      getCinemaList: function(cine_id) {
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
            } else {
              console.log("show error1 :", data.message);
            }
          })
          .catch((error) => {
            console.log("show error2 :", error);
          });
      },
      onDropdownChange: function(item, index) {
        console.log("Cinema", item);
        this.selectedCinema = item;
        this.cinema_id = item.cine_id;
      },
      getCMSData() {
        let loader = this.$loading.show();
        MyCinemaService.getAllMyCinemaCMS()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.CMSArray = data.Records;
                this.CMSArray.map((x, cmsIndex) => {
                  if (x.islanguageAvailable) {
                    x.keydata.map((y, langIndex) => {
                      if (y.image_url || y.sub_header) {
                        this.notempty[langIndex] = true;
                      }
                    });
                  }
                });
                console.log("data.Records", data.Records);
              }
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      finalSubmit() {
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          if (valid) {
            let payload = {
              cms_content: this.CMSArray,
            };
            MyCinemaService.UpdateCMS(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  this.$toasted.show(data.message);

                  this.$router.push({
                    path: "/",
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          }
        });
      },
    },
  };
</script>
<style>
  .section-collapse-box {
    border: 1px solid var(--lightgrey);
    border-radius: 10px;
    padding: 10px;
  }

  .cms-section-new .section-title {
    font-size: 22px;
  }

  .cms_header_image {
    max-width: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyCinemas/CMS/addCMS.vue